export const getSavingsAmount = (monthlyCost, yearlyCost) => {
    const totalMonthlyCost = monthlyCost * 12;
    const savings = totalMonthlyCost - yearlyCost;
    const percentageSavings = (savings / totalMonthlyCost) * 100;
    const rounded = Math.round(percentageSavings);
    return Number.isNaN(rounded) ? 25 : rounded;
  };